import Cookies from 'js-cookie';

const COOKIE_OPTIONS: Cookies.CookieAttributes = {
  path: '/',
  secure: true,
  sameSite: 'strict',
};

/**
 * Store a token in cookies.
 * @param key - The key for the token (e.g., 'accessToken', 'idToken', 'refreshToken').
 * @param value - The token value to store.
 */
const storeToken = (key: string, value: string) => {
  Cookies.set(key, value, COOKIE_OPTIONS);
};

/**
 * Retrieve a token from cookies.
 * @param key - The key for the token (e.g., 'accessToken', 'idToken', 'refreshToken').
 * @returns The token value or null if not found.
 */
const fetchToken = (key: string): string | null => {
  return Cookies.get(key) || null;
};

/**
 * Clear a token from cookies.
 * @param key - The key for the token (e.g., 'accessToken', 'idToken', 'refreshToken').
 */
const clearToken = (key: string) => {
  Cookies.remove(key, { path: '/' });
};

export { storeToken, fetchToken, clearToken };
